'use client';

import { c as _c } from "react/compiler-runtime";
import { Portal } from '@common/components';
import { cn } from '@core/utils';
import type { ReactNode } from 'react';
import { useBottomCTAAnimation } from './useBottomCTAAnimation';
export interface CartBottomCTADesktopProps {
  children: ReactNode;
  toastContent?: ReactNode;
  isHidden?: boolean;
  className?: string;
}
export const CartBottomCTADesktop = t0 => {
  const $ = _c(17);
  const {
    children,
    toastContent,
    isHidden: t1,
    className
  } = t0;
  const isHidden = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== isHidden || $[1] !== toastContent) {
    t2 = {
      isHidden,
      toastContent
    };
    $[0] = isHidden;
    $[1] = toastContent;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    isBottomVisible,
    isToastActive,
    displayToastContent
  } = useBottomCTAAnimation(t2);
  const t3 = isBottomVisible ? "translate-y-0" : "translate-y-full";
  let t4;
  if ($[3] !== className || $[4] !== t3) {
    t4 = cn("fixed inset-x-0 bottom-0 z-20 mx-auto flex w-full max-w-screen-xl flex-col items-center px-20 pb-20 transition-transform duration-300 ease-out", t3, className);
    $[3] = className;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = isToastActive ? "opacity-100" : "opacity-0";
  let t6;
  if ($[6] !== t5) {
    t6 = cn("mb-8 rounded-pill bg-Gray-black px-20 py-12 shadow-[0px_0px_8px_0px_rgba(0,0,0,0.04),0px_8px_10px_0px_rgba(0,0,0,0.05)] transition-opacity duration-300 ease-out", t5);
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== displayToastContent || $[9] !== t6) {
    t7 = <div className={t6}>{displayToastContent}</div>;
    $[8] = displayToastContent;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== children) {
    t8 = <div className="w-full rounded-xxlarge bg-Gray-white shadow-[0px_10px_15px_0px_rgba(0,0,0,0.06),0px_-2px_12px_0px_rgba(0,0,0,0.03)]">{children}</div>;
    $[11] = children;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t7 || $[15] !== t8) {
    t9 = <Portal><div className={t4}>{t7}{t8}</div></Portal>;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};